import Button from '../../Common/Button';
import Phrase from '../../Phrase/Phrase';
import Loading from '../../Loading/Loader';

import { useEffect } from 'react';
import { CloseIcon } from '../../../primitives/media/Icons';
import { WarningIcon } from '../../../primitives/media/Icons';
import { CloseWrapper, LoaderGeneralWrapper } from '../../../primitives/styles/Common/CommonStyle';
import {
  RippleWarningMsg,
  RippleInfoDetail,
  RippleModalWrapper,
  RippleInfoModalTitle,
  RippleInfoModalClose,
  RippleInfoModalContent,
  RippleWarningModalHeader,
  RippleWarningButtonsWrapper,
  RippleWarningModalDetailsWrapper,
} from '../../../primitives/styles/Ripples/RipplesStyle';

interface WarningModalProps {
  closeModal: () => void;
  onSubmit: () => void;
  inProgress: boolean;
  count: number;
}
const WarningModal: React.FC<WarningModalProps> = ({
  count,
  onSubmit,
  closeModal,
  inProgress
}) => {
  useEffect(() => {
    document.body.style.position = 'fixed';
    document.body.style.top = `-${window.scrollY}px`;
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
    };
  });

  return (
    <RippleModalWrapper>
      <RippleInfoModalContent>
        <RippleWarningModalHeader>
          <RippleInfoModalClose>
            <CloseWrapper style={{ padding: 0 }} onClick={closeModal}>
              <CloseIcon />
            </CloseWrapper>
          </RippleInfoModalClose>
          <RippleInfoModalTitle>
            <WarningIcon />
            <Phrase
              translationKey={'f2ff41c8-a814-452b-b8da-776cb93be2f6'}
              defaultText={'Heads up'}
            />
          </RippleInfoModalTitle>
        </RippleWarningModalHeader>
        <RippleWarningModalDetailsWrapper>
          {
            inProgress && 
            <LoaderGeneralWrapper>
              <Loading/>
            </LoaderGeneralWrapper>
          }
          {
            !inProgress &&
              <RippleInfoDetail>
                <RippleWarningMsg>
                  <Phrase
                    translationKey={'2392807a-04d1-4444-9b27-c29f30085a2e'}
                    defaultText={
                      'Selected designs will be deleted from all your RM devices.'
                    }
                  />
                </RippleWarningMsg>
                <RippleWarningMsg>
                  <Phrase
                    translationKey={'bc1de96a-814d-48ac-b040-7e848ba305a3'}
                    vars={{ X: String(count) }}
                    defaultText={
                      'Selected designs will be deleted from all your RM devices.'
                    }
                  />
                </RippleWarningMsg>
              </RippleInfoDetail>
          }
          {
            !inProgress && 
              <RippleWarningButtonsWrapper>
                <Button
                  onClick={closeModal}
                  isDisabled={false}
                  variant={'outlined'}
                  buttonText={'a9660b02-9248-4bc5-a5db-c7ebc53589e5'} //cancel
                  buttonDefaultText={'CANCEL'}
                />
                <Button
                  onClick={onSubmit}
                  isDisabled={false}
                  variant={'contained'}
                  buttonText={'219a55a8-6201-4fda-81ed-df7215848308'} //delete
                  buttonDefaultText={'DELETE'}
                />
              </RippleWarningButtonsWrapper>
          }
        </RippleWarningModalDetailsWrapper>
      </RippleInfoModalContent>
    </RippleModalWrapper>
  );
};

export default WarningModal;
